import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, FormControlLabel } from "@mui/material";
import { Grid, MenuItem, Radio, RadioGroup, Select } from "@mui/material";
import { TextField, Typography, Stack, styled } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "../reusableComponents/ToastComp";
import jsPDF from "jspdf";
import moment from "moment";
import employeeLogo from "../../images/employee.png";
import { v4 as uuidv4 } from "uuid";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import { getLedger } from "../ledgers/httpCalls";
import Repo from "../../Repository/Repo";

const Title = styled(Typography)({
  marginBottom: "10px",
  color: "#4EAF50",
  fontFamily: "Roboto",
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "25px",
  letterSpacing: "0em",
  textAlign: "center",
});

function AddVoucher({ onClose, onSuccess }) {
  const dispatch = useDispatch();
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const [voucher, setVoucher] = useState({
    ledgerName: "",
    ledgerType: "customer",
    date: "",
    totalKhata: "",
    newKhata: "",
    paid: "",
    received: "",
    checkedBy: "",
    receivedBy: "",
    discount: 0,
    description: "",
  });

  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  });

  const handleInput = (e) => {
    let { name, value } = e.target;
    setVoucher((state) => ({ ...state, [name]: value }));
  };

  const fetchLedger = async (id) => {
    let res = await getLedger(id);
    let amount;
    if (voucher.ledgerType == "customer") {
      if (res.saleTotal) {
        amount = res.saleTotal;
      } else {
        amount = 0;
      }
    } else if (voucher.ledgerType == "supplier") {
      if (res.purchaseTotal) {
        amount = res.purchaseTotal;
      } else {
        amount = 0;
      }
    }
    setVoucher((state) => ({ ...state, ledgerName: res, totalKhata: amount }));
  };

  const handleLedger = (e) => {
    let { value } = e.target;
    fetchLedger(value._id);
  };

  const handleLedgerType = (e) => {
    let { value } = e.target;
    let amount;
    handleInput(e);
    if (value == "customer") {
      if (voucher.ledgerName.saleTotal) {
        amount = voucher.ledgerName.saleTotal;
      } else {
        amount = 0;
      }
      setVoucher((state) => ({ ...state, totalKhata: amount, paid: "" }));
    } else if (value == "supplier") {
      if (voucher.ledgerName.purchaseTotal) {
        amount = voucher.ledgerName.purchaseTotal;
      } else {
        amount = 0;
      }
      setVoucher((state) => ({ ...state, totalKhata: amount, received: "" }));
    }
  };

  const Register = async (data) => {
    if (data.ledgerName == "") {
      Toast("info", "Kindly select Ledger");
      return;
    }
    if (data.date == "") {
      Toast("info", "Kindly select Date");
      return;
    }
    if (data.newKhata == "") {
      Toast("info", "Kindly add New Amount");
      return;
    }
    if (data.checkedBy == "") {
      Toast("info", "Kindly fill Checked By");
      return;
    }
    if (data.receivedBy == "") {
      Toast("info", "Kindly fill Received By");
      return;
    }
    if (data.paid == "" && data.received == "") {
      Toast("info", "Kindly fill Paid or Received");
      return;
    }
    onClose();
    let srnums = uuidv4();
    let newledger = {
      srNum: srnums,
      date: +new Date(),
      detail: "New " + data.ledgerType + " ledger created ",
      totalAmount: data.newKhata,
      depositedAmount: data.received,
      remainingAmount: data.received
        ? data.newKhata - data.discount - data.received
        : data.paid,
    };
    if (data.ledgerType == "supplier") {
      let res = await Repo.ledger({
        request: {
          method: "updatePurchaseLedger",
          data: {
            _id: data.ledgerName._id,
            purchase: newledger,
          },
        },
      });
      if (res.data.response.status.statusCode == 200) {
        Toast("success", "Ledger Entry Created");
      } else {
        Toast("error", "Ledger Entry No Created");
      }
    } else {
      let res = await Repo.ledger({
        request: {
          method: "updateSaleLedger",
          data: {
            _id: data.ledgerName._id,
            sale: newledger,
          },
        },
      });
      if (res.data.response.status.statusCode == 200) {
        Toast("success", "Ledger Entry Created");
      } else {
        Toast("error", "Ledger Entry Nort Created");
      }
    }
    let res = await Repo.voucher({
      request: {
        method: "saveVoucher",
        data: {
          voucher: {
            date: data.date,
            ledger_id: data.ledgerName._id,
            ledgerName: data.ledgerName.name,
            newAmount: data.newKhata,
            discount: data.discount ? data.discount : 0,
            totalKhata: data.totalKhata,
            ledger_type: data.ledgerType,
            received: data.received,
            paid: data.paid,
            description: data.description,
            received_by: data.receivedBy,
            checked_by: data.checkedBy,
            company_code: localStorage.getItem("companyCode"),
          },
        },
      },
    });

    if (res.data.response.status.statusCode == 200) {
      Toast("success", "New Voucher Created");
    } else {
      Toast("error", "Voucher not Created");
    }
    print(data, "new");
    onSuccess();
  };
  const print = (data, type) => {
    let ledgerName;
    let newAmount;
    let totalKhata;
    let receivedBy;
    let checkedBy;
    let ledgerType;

    if (type == "new") {
      ledgerName = data?.ledgerName?.name;
      newAmount = data?.newKhata;
      totalKhata = data?.totalKhata;
      receivedBy = data?.receivedBy;
      checkedBy = data?.checkedBy;
      ledgerType = data?.ledgerType;
    } else {
      ledgerName = data?.ledgerName;
      newAmount = data?.newAmount;
      totalKhata = data?.totalKhata;
      receivedBy = data?.received_by;
      checkedBy = data?.checked_by;
      ledgerType = data?.ledger_type;
    }
    let doc = new jsPDF();
    doc.setFontSize(18);
    doc.setFontStyle("bold");
    doc.text(localStorage.getItem("company") || "", 50, 20);
    doc.text(localStorage.getItem("address") || "", 50, 40);
    doc.text(localStorage.getItem("phone") || "", 50, 60);
    doc.text("Date # " + moment(data.date).format("DD-MM-YYYY") || "", 150, 20);
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.text("Date", 21, 90);
    doc.text("Description", 21, 110);

    doc.text("Total", 50, 90);
    doc.text("Discount", 111, 90);
    doc.text("Amount", 140, 90);
    if (ledgerType == "customer") {
      doc.text("Receive", 170, 90);
    } else {
      doc.text("Paid", 170, 90);
    }
    doc.cell(20, 84, 170, 8, " ");
    let y = 92;
    doc.setFontSize(14);
    doc.setFontStyle("bold");
    doc.cell(20, y, 25, 6, " ");
    doc.cell(45, y, 67, 6, " ");
    doc.cell(112, y, 25, 6, " ");
    doc.cell(137, y, 28, 6, " ");
    doc.cell(165, y, 25, 6, " ");

    doc.setFontSize(12);
    doc.setFontStyle("normal");
    let arrs = "";
    for (let i = 0; i < data.description.length; i++) {
      if ((i + 1) % 30 == 0) {
        arrs = arrs + data.description.charAt(i) + "\n";
      } else {
        arrs = arrs + data.description.charAt(i);
      }
    }
    doc.text(arrs, 54, 110);
    doc.text(
      data.date ? moment(data.date).format("DD-MM-YYYY") : "",
      22,
      y + 5
    );
    let total = parseInt(totalKhata) + parseInt(newAmount);
    doc.text(total ? total.toString() : "", 54, y + 5);
    doc.text(data.discount ? data.discount.toString() : "0", 118, y + 5);
    if (ledgerType == "customer") {
      doc.text(data.received ? data.received.toString() : "", 168, y + 5);
    } else {
      doc.text(data.paid ? data.paid.toString() : "", 168, y + 5);
    }

    doc.text(newAmount ? newAmount.toString() : "", 144, y + 5);
    y = y + 6;

    if (y >= 240) {
      doc.addPage();
      y = 20;
    }
    doc.text("Received By", 138, y + 10);
    doc.text("Checked By", 138, y + 15);
    doc.text("Ledger Name", 138, y + 20);
    doc.text(receivedBy ? receivedBy : "", 168, y + 10);
    doc.text(checkedBy ? checkedBy : "", 168, y + 15);
    doc.text(ledgerName ? ledgerName : "", 168, y + 20);

    doc.text("Checked By", 138, y + 15);
    let img = new Image();
    let baseUrl = localStorage.getItem("base_url");
    if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
      let snapshot = employeeLogo;
      img.src = snapshot;
    } else {
      let snapshot = localStorage.getItem("base_url");
      img.src = snapshot;
    }
    doc.addImage(img, "png", 0, 0, 40, 40);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  };
  return (
    <Box>
      <Title sx={{ mt: "-1px" }} variant="h6">
        New Voucher !
      </Title>
      <Grid align="left" container spacing={2}>
        <Grid item md={4} sm={6} xs={12}>
          <FormControl fullWidth size="small">
            <Typography variant="body1">Select Ledger :</Typography>
            <Select
              defaultValue=""
              variant="outlined"
              placeholder="Ledger Name"
              name="ledgerName"
              fullWidth
              onChange={handleLedger}
            >
              {ledgersNames?.map((item, index) => {
                return (
                  <MenuItem key={index} value={item}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Typography variant="body1">Date :</Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            placeholder="Ledger Name"
            name="date"
            onChange={handleInput}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Typography variant="body1">Total Khata :</Typography>
          <TextField
            fullWidth
            size="small"
            disabled
            variant="outlined"
            placeholder="Total Khata"
            value={voucher.totalKhata}
            name="totalKhata"
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Typography variant="body1">New Khata :</Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            placeholder="New Khata"
            name="newKhata"
            value={voucher.newKhata}
            onChange={handleInput}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          <Typography variant="body1">Discount :</Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            placeholder="0"
            name="discount"
            value={voucher.discount}
            onChange={handleInput}
          />
        </Grid>
        <Grid item md={4} sm={6} xs={12}>
          {voucher.ledgerType == "customer" && (
            <>
              <Typography variant="body1">Received :</Typography>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="number"
                placeholder="Received"
                name="received"
                value={voucher.received}
                onChange={handleInput}
              />
            </>
          )}
          {voucher.ledgerType == "supplier" && (
            <>
              <Typography variant="body1">Paid :</Typography>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="number"
                placeholder="Paid"
                name="paid"
                value={voucher.paid}
                onChange={handleInput}
              />
            </>
          )}
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant="body1">Check by :</Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Check by"
            name="checkedBy"
            value={voucher.checkedBy}
            onChange={handleInput}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant="body1">Received by :</Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Received by"
            name="receivedBy"
            value={voucher.receivedBy}
            onChange={handleInput}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <FormControl>
            <RadioGroup
              name="ledgerType"
              value={voucher.ledgerType}
              onChange={handleLedgerType}
            >
              <FormControlLabel
                value="customer"
                control={<Radio />}
                label="Sale Ledger"
              />
              <FormControlLabel
                value="supplier"
                control={<Radio />}
                label="Purchase Ledger"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={4}
            variant="outlined"
            placeholder="Add Description"
            name="description"
            value={voucher.description}
            onChange={handleInput}
          />
        </Grid>
      </Grid>

      <Stack
        direction="row"
        spacing={4}
        justifyContent="space-evenly"
        marginTop="20px"
      >
        <Button
          fullWidth
          sx={{
            backgroundColor: "rgb(138, 138, 138) !important",
            color: "white",
            borderRadius: "5px",
            textShadow: "1px 1px 2px rgb(161, 161, 161)",
            boxShadow: "0px 1px 2px rgb(161, 161, 161)",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button fullWidth variant="contained" onClick={() => Register(voucher)}>
          Add
        </Button>
      </Stack>
    </Box>
  );
}

export default AddVoucher;
